import React from "react";
import { withRouter } from "react-router-dom";

class LocationWatcherBase extends React.PureComponent {
  componentDidMount() {
    // Notifica ubicación inicial
    this.notify(this.props.location);
    this.unlisten = this.props.history.listen((location /*, action*/) => {
      this.notify(location);
    });
  }

  componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  }

  notify = (location) => {
    if (typeof this.props.onChange === "function") {
      this.props.onChange(location);
    }
  };

  render() {
    return null;
  }
}

export default withRouter(LocationWatcherBase);
